module.exports = __webpack_public_path__ + "img/12 PORTRAIT.9ffc2f0c.png";